import classNames from 'classnames';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { DarkSkeleton } from '@eika/skeleton';

import './EFakturaItem.scss';

const EFakturaItemSkeleton: React.FC<{ darkSkeleton?: boolean }> = ({ darkSkeleton = false }) => {
    return (
        <li className="eFaktura-item eFaktura-item__skeleton" tabIndex={-1}>
            <div className={classNames('eFaktura-item__button', { 'dark-skeleton': darkSkeleton })}>
                <span className="eFaktura-item__due-date">
                    {darkSkeleton ? <DarkSkeleton height={15} width={60} /> : <Skeleton height={15} width={60} />}
                    {darkSkeleton ? <DarkSkeleton height={15} width={60} /> : <Skeleton height={15} width={60} />}
                </span>
                <span className="eFaktura-item__receiver-and-amount">
                    <span className="eFaktura-item__receiver-name">
                        {darkSkeleton ? (
                            <DarkSkeleton height={17} width={170} className="eFaktura-item__skeleton-element" />
                        ) : (
                            <Skeleton height={17} width={170} className="eFaktura-item__skeleton-element" />
                        )}
                    </span>
                    <span>
                        {darkSkeleton ? <DarkSkeleton height={17} width={120} /> : <Skeleton height={17} width={40} />}
                    </span>
                </span>
            </div>
        </li>
    );
};

export default EFakturaItemSkeleton;
